// extracted by mini-css-extract-plugin
module.exports = {"button":"NavButton_button__1AEmj","small":"NavButton_small__2guGF","large":"NavButton_large__3BdlW"};